﻿{
  "createAccount": "Создать учетную запись",
  "subscription": "Подписка",
  "oneTimePurchase": "Разовая покупка",
  "billingDetails": "Реквизиты для выставления счетов",
  "paymentDetails": "Платежные реквизиты",
  "requestAQuote": "Форма запроса организации",
  "reviewOrder": "Рассмотреть заказ",
  "thankYouForYourOrder": "Спасибо за Ваш заказ!",
  "joinTheCommunity": "Присоединиться к сообществу",
  "startTrial": "Начать пробный период",
  "yourTrialHasEnded": "Ваш пробный период истек",
  "taxExempt": "Налоговая льгота",
  "taxExemptThankYou": "Выгрузка завершилась успешно!",
  "planDetails": "Сведения о моей подписке",
  "modifyPlan": "Изменить план",
  "modifyPaymentDetails": "Изменить платежные реквизиты",
  "redirect": "Переадресация на Boardmaker",
  "perpetualTrial": "Скачайте {{trialLength}}-дневную бесплатную пробную версию",
  "perpetualThankYou": "Ваше программное обеспечение готово!",
  "downloads": "Cкачать Boardmaker",
  "partner": "Найти партнера",
  "intro": "Выберите продукт Boardmaker, чтобы загрузить последнюю версию для вашего устройства.",
"systemRequirements": "Системные требования",
"releaseNotes": "Примечания к выпуску",
"comparison": "Сравнение Подписки и Лицензии"
}
